export default {"src":"/_next/static/media/password-stars.7e684e2e.svg","height":11,"width":183,"blurWidth":0,"blurHeight":0};